// extracted by mini-css-extract-plugin
export default {"iconPicker":"IconPicker_iconPicker__OUWJ6","iconCard":"IconPicker_iconCard__UsR1-","leftcol":"IconPicker_leftcol__yEYPw","rightcol":"IconPicker_rightcol__0UuJ3"};